/*global VeloxGridController*/

var listingController = new VeloxGridController("customer", {
        directory: "views/listing",
        name: "optInGrid",
        route: "optinAdmin",
        canCreate: false, 
        searchRecords: {  },
        joinFetch : [
            { otherTable: "reseller"},
            { otherTable: "pool", type: "2one"},
            { otherTable: "spa", type: "2one"},
        ]
    }
);

listingController.searchRecords = function(callback){
    VeloxGridController.prototype.searchRecords.call(this, function(err, results){
        if(err){ return callback(err) ;}
        results = results.filter(function(r){
            return (r.c_optin_bayrol || r.c_optin_newsletter) && r.reseller && r.reseller.r_lang === this.routeData ;
        }.bind(this));
        callback(null, results) ;
    }.bind(this));
} ;


module.exports = listingController ;